import React, { useCallback, useEffect, useState } from "react";
import TableCustom from "../../../component/table/tableCustom";
import ReportApi from "../../../api/reports/reports.api";
import TableRowCommon from "../../../component/table/TableRowCommon";
import { numberFormat } from "../../../utils/common";

const ContractReport = ({
  date_start,
  date_end,
  search_type,
}: {
  date_start: string;
  date_end: string;
  search_type: string;
}) => {
  const [data, setData] = useState<any>([]);

  const transformData = (
    data: Record<string, { monthlyCount: string; dailyCount: string }>
  ) => {
    return [
      {
        name: "เดือน",
        contract_new: Number(data?.new_lease_agreement?.monthlyCount) || 0,
        contract_transfer:
          Number(data?.transfer_lease_agreement?.monthlyCount) || 0,
        contract_cancel:
          Number(data?.cancel_lease_agreement?.monthlyCount) || 0,
      },
      {
        name: "วัน",
        contract_new: Number(data?.new_lease_agreement?.dailyCount) || 0,
        contract_transfer:
          Number(data?.transfer_lease_agreement?.dailyCount) || 0,
        contract_cancel: Number(data?.cancel_lease_agreement?.dailyCount) || 0,
      },
    ];
  };

  const handleGetData = useCallback(async () => {
    let condition: any = {
      start_date: date_start ?? "",
      end_date: date_end ?? "",
      type: search_type.toLowerCase() ?? "",
    };

    try {
      const res = await ReportApi.getAgreement(condition);

      if (res.status === 200 && res.data) {
        const transformedArray = transformData(res.data.data);

        setData(transformedArray);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [date_start, date_end, search_type]);

  useEffect(() => {
    handleGetData();
  }, [handleGetData]);

  const headCells = [
    {
      id: "no",
      disablePadding: false,
      label: "#",
      align: "center",
    },
    {
      id: "type",
      disablePadding: false,
      label: "ประเภทสัญญา",
      align: "center",
    },
    {
      id: "transfer",
      disablePadding: false,
      label: "โอนสัญญา",
      align: "center",
    },
    {
      id: "new",
      disablePadding: false,
      label: "สัญญาใหม่",
      align: "center",
    },
    {
      id: "cancel",
      disablePadding: false,
      label: "ยกเลิกสัญญา",
      align: "center",
    },
  ];

  const renderData = (objData: any, no: any) => {
    const { name, contract_transfer, contract_new, contract_cancel } = objData;

    const objRenderData = {
      key: no,
      id: no,
      obj: objData,
      columns: [
        { option: "TEXT", align: "center", label: no + 1 },
        {
          option: "TEXT",
          align: "center",
          label: name || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: numberFormat(contract_transfer, 0, 0) || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: numberFormat(contract_new, 0, 0) || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: numberFormat(contract_cancel, 0, 0) || "-",
        },
      ],
    };

    return <TableRowCommon {...objRenderData} />;
  };

  return (
    <div>
      <TableCustom
        headCells={headCells}
        customScroll
        page={1}
        pageLimit={1}
        hidePagination
        sortType={"ASC"}
        sortBy=""
        rowCount={0}
        rowsData={
          data &&
          data?.map((d: any, index: any) => {
            return renderData(d, index);
          })
        }
        onSort={() => {}}
        setPageLimit={(newValue) => {}}
        setPage={(newValue) => {}}
      />
    </div>
  );
};

export default ContractReport;
